// Objectives arrive as raw enum keys (e.g. `CONVERT_LEADS`). Unknown keys are
// humanized so we never surface SCREAMING_SNAKE_CASE if the backend adds a value
// that isn't yet present in the filter config response.
function humanizeObjective(objective) {
  const humanized = objective.toLowerCase().split('_').filter(Boolean).join(' ');
  return humanized.charAt(0).toUpperCase() + humanized.slice(1);
}

/**
 * Resolves the display label for a workflow objective key. Labels are owned by
 * the backend and sourced from the `OBJECTIVE` search filter config
 * (see `useWorkflowObjectiveLabels`), falling back to a humanized key while the
 * config loads or for values missing from the config.
 */
export function getWorkflowObjectiveLabel(objective, labelsByKey) {
  var _labelsByKey$objectiv;
  return (_labelsByKey$objectiv = labelsByKey[objective]) !== null && _labelsByKey$objectiv !== void 0 ? _labelsByKey$objectiv : humanizeObjective(objective);
}